module.exports = __webpack_public_path__ + "static/media/blog-details.e807d48f.jpg";